import { CaixaModel } from "./../../model/caixa/caixa.model";
import { DialogCodAlternativoComponent } from "./dialog-cod-alternativo/dialog-cod-alternativo.component";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { CaixaService } from "./../../service/caixa/caixa.service";
import { AreaService } from "./../../service/cliente/area.service";
import { TipoCaixaModel } from "./../../model/caixa/tipocaixa.model";
import { TipoCaixaService } from "./../../service/caixa/tipo-caixa.service";
import { ClienteModel } from "./../../model/cliente/cliente.model";
import { ClienteService } from "./../../service/cliente/cliente.service";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "@alfresco/adf-core";
import { Component, OnInit } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { GerarRgsComponent } from "./gerar-rgs/gerar-rgs.component";
import { ListaRgsComponent } from "./lista-rgs/lista-rgs.component";
import { DialogConfirmComponent } from "../dialog/dialog-confirm/dialog-confirm.component";
import { stat } from "fs";

@Component({
  selector: "app-caixa",
  templateUrl: "./caixa.component.html",
  styleUrls: ["./caixa.component.scss"],
})
export class CaixaComponent implements OnInit {
  // Variáveis usadas neste component
  public cliente = {} as ClienteModel;
  public clientes: ClienteModel[];
  public tiposCaixas: TipoCaixaModel[];
  // public statusGuarda: "";
  public areas: any[] = [];
  public usuario;
  public caixa = {} as CaixaModel;
  public caixaForm: FormGroup;
  public submit = false;
  public selectCliente = true;
  public disableSave = false;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public status = "EM_PROCESSO_DE_CADASTRO";
  public loading = true;
  public listaArea = false;
  animal: string;
  code: string;
  idCliente: number;
  idArea: number;
  disabledCod = true;
  caixaId;
  codAlternativo;
  deData;
  adm = false;
  acervo = true;
  solicitacao = false;
  public clienteCache;
  public areaCache;
  public tipoCaixaCache;
  public checkBoxNr;
  public disabledCheck = true;
  MAX_CHARS = 100;

  // Construtor
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private caixaService: CaixaService,
    private clienteService: ClienteService,
    private tipoCaixaService: TipoCaixaService,
    private areaService: AreaService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {}

  // Chamadas feitas na inicialização do component: CaixaComponent
  ngOnInit() {
    // montando formulário da caixa
    this.caixaForm = this.fb.group({
      cliente: [null, Validators.required],
      usuarioReponsavelAbertura: ["", Validators.required],
      area: [null, Validators.required],
      tipoCaixa: [TipoCaixaModel, Validators.required],
      rgCaixa: ["", Validators.required],
      numeroCaixa: ["", Validators.required],
      codAlternativo: [""],
      dataInicial: [""],
      dataFinal: [""],
      dataAbertura: [""],
      qtdItens: [""],
      lacre1: [""],
      lacre2: [""],
      statusCaixa: [""],
      descricaoConteudoCaixa: ["", this.noSpacesMaxLengthValidator(100)],
      incluirConteudo: [false],
      statusGuarda: [null, Validators.required],
    });
    this.caixaForm.get("incluirConteudo").setValue(false);
    this.caixaForm.get("statusCaixa").setValue(this.status);
    this.caixaForm.get("area").disable();
    this.buscarCamposEmCache();
    this.listarClientesUsuario();
    this.listarTiposDeCaixas();
    this.getUserResponsavel(sessionStorage.getItem("ACS_USERNAME"));
  }

  buscarCamposEmCache() {
    const cliente = localStorage.getItem("RM_CLIENTE_CACHE");
    const area = localStorage.getItem("RM_AREA_CACHE");
    const tipoCaixa = localStorage.getItem("RM_TIPO_CAIXA_CACHE");
    if (cliente !== null && area !== null && tipoCaixa !== null) {
      this.caixaForm.get("cliente").setValue(JSON.parse(cliente));
      this.caixa.cliente = JSON.parse(cliente);
      this.disabledCod = false;
      this.caixaForm.get("area").enable();
      const clienteId = JSON.parse(cliente).id;
      this.idCliente = clienteId;
      this.listarAreasCliente(clienteId);
      this.caixaForm.get("area").setValue(JSON.parse(area));
      this.caixa.area = JSON.parse(area);
      this.caixaForm.get("tipoCaixa").setValue(JSON.parse(tipoCaixa));
      this.caixa.tipoCaixa = JSON.parse(tipoCaixa);
      this.disabledCheck = false;
    }
  }

  getCacheUnico(idCliente) {
    this.caixaService.cacheCodAlternativoUnico(idCliente).subscribe(
      (data) => {
        // console.log(data);
        this.loading = false;
        this.codAlternativo = data;
        this.caixaForm
          .get("codAlternativo")
          .setValue(this.codAlternativo.codAlternativo);
      },
      (err) => {
        this.loading = false;
        console.error(err);
      }
    );
  }

  getCaixaUnica(caixaId: number) {
    this.caixaService.getCaixaUnica(caixaId).subscribe(
      (data) => {
        this.caixa = data;
        this.caixaForm.get("cliente").setValue(data.cliente);
        this.caixaForm.get("area").enable();
        this.listarAreasCliente(data.cliente.id);
        this.caixaForm.get("area").setValue(data.area);
        this.disabledCod = false;
        this.disabledCheck = false;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  compararEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararClienteEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.nome === obj2.nome && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararAreaEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  openDialogCod(): void {
    const dialogRef = this.dialog.open(DialogCodAlternativoComponent, {
      width: "500px",
      data: { idCliente: this.cliente },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log(`The dialog was closed - ${result}`);
      this.code = result;
      this.caixaForm.get("codAlternativo").setValue(this.code);
      // console.log(result);
    });
  }

  gerarRgs(): void {
    const dialogRef = this.dialog.open(GerarRgsComponent, {
      width: "500px",
      data: { idCliente: this.idCliente },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // console.log(`The dialog was closed - ${result}`);
      this.code = result;
      this.caixaForm.get("codAlternativo").setValue(this.code);
      // console.log(result);
    });
  }

  listarRgs() {
    const dialogRef = this.dialog.open(ListaRgsComponent, {
      width: "500px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.caixaForm.get("rgCaixa").setValue(result);
    });
  }

  checkValue(event: any) {
    const area = localStorage.getItem("RM_AREA_CACHE");
    const jsonArea = JSON.parse(area);
    if (event.currentTarget.checked === true) {
      this.loading = true;
      this.caixaService
        .buscarNumeroCaixa(
          this.idCliente,
          this.idArea !== undefined ? this.idArea : jsonArea.id
        )
        .subscribe(
          (data) => {
            this.caixaForm.get("numeroCaixa").setValue(data);
            this.loading = false;
            // let codigoAdd: any = new Number(data);
            // this.caixaForm.get('numeroCaixa').setValue(codigoAdd + 1);
          },
          (err) => {
            console.error(err);
            this.loading = false;
            if (err.status === 200) {
              this.caixaForm.get("numeroCaixa").setValue(1);
            } else if (err.status === 400) {
              this.openSnackBarError(
                "Erro ! Selecione um cliente antes de buscar um número de caixa automático."
              );
            } else {
              this.openSnackBarError("Erro ao tentar gerar o número de caixa.");
            }
          }
        );
    } else {
      this.caixaForm.get("numeroCaixa").setValue(null);
    }
  }

  resetCheck() {
    const checkElement = document.getElementById(
      "codAutomatico"
    ) as HTMLInputElement | null;
    checkElement.checked = false;
  }

  buscarNumeroCaixa(clienteId: number, areaId: number) {
    this.caixaService.buscarNumeroCaixa(clienteId, areaId).subscribe(
      (data) => {
        // console.log(data);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarTiposDeCaixas() {
    this.tipoCaixaService.getTipoCaixasUsuario().subscribe(
      (data) => {
        this.tiposCaixas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  listarAreasCliente(idCliente: number) {
    this.areaService.getAreasUsuarioCliente(idCliente).subscribe(
      (data) => {
        this.areas = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getUserResponsavel(userId: string) {
    this.caixaService.getUsuarioCaixa(userId).subscribe(
      (data) => {
        this.usuario = data;
        this.caixaForm
          .get("usuarioReponsavelAbertura")
          .setValue(this.usuario.nome);
        this.loading = false;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getClienteById(idCliente: number) {
    this.clienteService.getClienteUnico(idCliente).subscribe(
      (data) => {
        this.cliente = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  onChange(event) {
    this.clienteCache = this.caixaForm.get("cliente").value;
    localStorage.setItem("RM_CLIENTE_CACHE", JSON.stringify(this.clienteCache));
    const idCliente = this.caixaForm.get("cliente").value.id;
    this.getCacheUnico(idCliente);
    this.getClienteById(idCliente);
    this.idCliente = idCliente;
    this.selectCliente = false;
    this.disabledCod = false;
    this.caixaForm.get("area").enable();
    this.disabledCheck = false;
    this.listarAreasCliente(idCliente);
    this.listaArea = true;
  }

  onChangeArea() {
    console.log();
    let area = this.caixaForm.get("area").value;
    this.idArea = area.id;
    this.areaCache = this.caixaForm.get("area").value;
    localStorage.setItem("RM_AREA_CACHE", JSON.stringify(this.areaCache));
  }

  onChangeTipoCaixa() {
    this.tipoCaixaCache = this.caixaForm.get("tipoCaixa").value;
    localStorage.setItem(
      "RM_TIPO_CAIXA_CACHE",
      JSON.stringify(this.tipoCaixaCache)
    );
  }

  onSubmit() {
    this.submit = true;
    if (this.caixaForm.valid) {
      this.saveCaixaDialog();
    } else {
      this.openSnackBarError("Preencha todos os campos obrigatórios !");
    }
  }

  saveCaixa() {
    if (this.caixaForm.valid) {
      this.loading = true;
      this.caixaService.saveCaixa(this.caixaForm.value).subscribe(
        (data) => {
          if (data.cod !== 200) {
            this.openSnackBarError(data.message);
            this.loading = false;
          } else {
            this.loading = false;
            this.openSnackBarSuccess(
              `Caixa com o RG: ${data.result.rgCaixa} salva com sucesso !`
            );
            if (data.result.incluirConteudo === true) {
              const idCrypt = encodeURIComponent(
                CryptoJS.AES.encrypt(
                  JSON.stringify(data.result.id),
                  "pcdoc"
                ).toString()
              );
              setTimeout(() => {
                setTimeout(() => {
                  this.router.navigate(["/incluir-conteudo", idCrypt]);
                }, 1000);
                this.openSnackBarSuccess(
                  "Redirecionando para página da caixa criada !"
                );
              }, 3000);
            } else {
              this.clearInputs();
            }
            /*
          else {
            setTimeout(() => {
              setTimeout(() => {
                this.router.navigate(['/listar-caixas']);
              }, 1000);
              this.openSnackBarSuccess('Redirecionando para página de caixas !');
            }, 3000);
          } */
          }
        },
        (err) => {
          console.error(err);
          this.loading = false;
          if (err.error.errors !== undefined) {
            this.openSnackBarError(err.error.errors[0].defaultMessage);
          } else {
            this.openSnackBarError(err.error.message);
          }
        }
      );
    } else {
      this.openSnackBarError("Preencha todos os campos obrigatórios !");
    }
  }

  clearInputs() {
    this.submit = false;
    this.caixaForm.get("rgCaixa").reset();
    this.caixaForm.get("numeroCaixa").reset();
    this.caixaForm.get("codAlternativo").reset();
    this.caixaForm.get("dataInicial").reset();
    this.caixaForm.get("dataFinal").reset();
    this.caixaForm.get("dataAbertura").reset();
    this.caixaForm.get("qtdItens").reset();
    this.caixaForm.get("lacre1").reset();
    this.caixaForm.get("lacre2").reset();
    this.caixaForm.get("statusCaixa").setValue("EM_PROCESSO_DE_CADASTRO");
    this.caixaForm.get("descricaoConteudoCaixa").reset();
    this.caixaForm.get("incluirConteudo").setValue(false);
    this.caixaForm.get("statusGuarda").reset();
    this.resetCheck();
  }

  saveCaixaAndClose() {
    if (this.caixaForm.valid) {
      this.loading = true;
      this.caixaService.saveCaixaAndClose(this.caixaForm.value).subscribe(
        (data) => {
          if (data.cod !== 200) {
            this.openSnackBarError(data.message);
            this.loading = false;
          } else {
            this.loading = false;
            this.openSnackBarSuccess(
              `Caixa com o RG: ${data.result.rgCaixa} salva com sucesso !`
            );
            if (data.result.incluirConteudo === true) {
              const idCrypt = encodeURIComponent(
                CryptoJS.AES.encrypt(
                  JSON.stringify(data.result.id),
                  "pcdoc"
                ).toString()
              );
              setTimeout(() => {
                setTimeout(() => {
                  this.router.navigate(["/incluir-conteudo", idCrypt]);
                }, 1000);
                this.openSnackBarSuccess(
                  "Redirecionando para página da caixa criada !"
                );
              }, 3000);
            } else {
              this.clearInputs();
            }
          }
        },
        (err) => {
          console.error(err);
          this.loading = false;
          if (err.error.errors !== undefined) {
            this.openSnackBarError(err.error.errors[0].defaultMessage);
          } else {
            this.openSnackBarError(err.error.message);
          }
        }
      );
    } else {
      this.openSnackBarError("Preencha todos os campos obrigatórios !");
    }
  }

  saveCaixaDialog() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja salvar e fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.",
        from: "caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.saveCaixaAndClose();
      } else {
        this.saveCaixa();
      }
    });
  }

  editCaixa(caixa: CaixaModel) {
    this.caixaService.editarCaixa(caixa).subscribe(
      (data) => {
        // console.log(data);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  reset() {
    this.submit = false;
    this.listaArea = false;
    this.disabledCod = true;
    this.caixaForm.get("cliente").reset();
    this.caixaForm.get("area").reset();
    this.caixaForm.get("tipoCaixa").reset();
    this.caixaForm.get("rgCaixa").reset();
    this.caixaForm.get("numeroCaixa").reset();
    this.caixaForm.get("codAlternativo").reset();
    this.caixaForm.get("dataInicial").reset();
    this.caixaForm.get("dataFinal").reset();
    this.caixaForm.get("dataAbertura").reset();
    this.caixaForm.get("qtdItens").reset();
    this.caixaForm.get("lacre1").reset();
    this.caixaForm.get("lacre2").reset();
    this.caixaForm.get("descricaoConteudoCaixa").reset();
    this.caixaForm.get("incluirConteudo").setValue(false);
    this.caixaForm.get("statusGuarda").reset();
  }

  isFormInvalid(): boolean {
    return (
      this.caixaForm.get("cliente").value.email === null ||
      this.caixaForm.get("usuarioReponsavelAbertura").value === null ||
      this.caixaForm.get("area").value.descricao === null ||
      this.caixaForm.get("tipoCaixa").value.descricao === null ||
      this.caixaForm.get("rgCaixa").value === null ||
      this.caixaForm.get("numeroCaixa").value === null ||
      this.caixaForm.get("codAlternativo").value === null ||
      this.caixaForm.get("dataInicial").value === null ||
      this.caixaForm.get("dataFinal").value === null ||
      this.caixaForm.get("dataAbertura").value === null ||
      this.caixaForm.get("statusGuarda").value === null
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  getCharCount(value: string): number {
    if (!value) {
      return 0;
    }
    // remove todos os espaços em branco e conta
    return value.replace(/\s+/g, "").length;
  }
noSpacesMaxLengthValidator(max: number) {
  return (control: any) => {
    if (!control.value) return null;
    const length = control.value.replace(/\s+/g, "").length;
    return length > max ? { maxCharsNoSpaces: true } : null;
  };
}

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/caixa.component.ts